interface GetNpcStorageAction {
  type: NpcStorageActionTypes.GET_NPC_STORAGE;
  payload: any;
}

interface GetNpcStorageParamsAction {
  type: NpcStorageActionTypes.GET_NPC_STORAGE_PARAMS;
  payload: any;
}

interface GetNpcStorageBrandAction {
  type: NpcStorageActionTypes.GET_NPC_STORAGE_BRAND;
  payload: any;
}

interface GetNpcStorageMinDateAction {
  type: NpcStorageActionTypes.GET_NPC_STORAGE_MINDATE;
  payload: string;
}

interface SetNpcStorageLoadingAction {
  type: NpcStorageActionTypes.SET_NPC_STORAGE_LOADING;
}

interface SetNpcStorageBrandLoadingAction {
  type: NpcStorageActionTypes.SET_NPC_STORAGE_BRAND_LOADING;
}

interface ClearNpcStorageAction {
  type: NpcStorageActionTypes.CLEAR_NPC_STORAGE;
}

export enum NpcStorageActionTypes {
  GET_NPC_STORAGE = 'GET_NPC_STORAGE',
  GET_NPC_STORAGE_BRAND = 'GET_NPC_STORAGE_BRAND',
  GET_NPC_STORAGE_PARAMS = 'GET_NPC_STORAGE_PARAMS',
  GET_NPC_STORAGE_MINDATE = 'GET_NPC_STORAGE_MINDATE',
  SET_NPC_STORAGE_LOADING = 'SET_NPC_STORAGE_LOADING',
  SET_NPC_STORAGE_BRAND_LOADING = 'SET_NPC_STORAGE_BRAND_LOADING',
  CLEAR_NPC_STORAGE = 'CLEAR_NPC_STORAGE',
}

export interface NpcStorageState {
  totalQty: number;
  totalAmount: number;
  totalAverage: number;
  chart: any[];
  table: any[];
  brand: {
    table: any[];
    headers: any[];
  };
  lists: {
    brands: [];
    categories: [];
    sizes: [];
  };
  min_date: null | string;
  loading: boolean;
  loading_brand: boolean;
  loading_lists: boolean;
}

export type NpcStorageAction =
  | ClearNpcStorageAction
  | GetNpcStorageAction
  | GetNpcStorageParamsAction
  | GetNpcStorageBrandAction
  | SetNpcStorageLoadingAction
  | SetNpcStorageBrandLoadingAction
  | GetNpcStorageMinDateAction;
